import bootScreen from '../views/bootScreen/bootScreen.vue'
import bootScreenShu from '../views/bootScreen/bootScreenShu.vue'
// 校园简介
import schoolIntroduction from '../views/bootScreen/schoolIntroduction/schoolIntroduction.vue'
import bigSchoolIntroduction from '../views/bootScreen/schoolIntroduction/bigSchoolIntroduction.vue'
import videoSchoolIntroduction from '../views/bootScreen/schoolIntroduction/videoSchoolIntroduction.vue'
// 校园动态
import campusDynamic from '../views/bootScreen/campusDynamic/campusDynamic.vue'
// 校园动态-图片
import bigCampusDynamic from '../views/bootScreen/campusDynamic/bigCampusDynamic.vue'
// 校园动态-视频
import videoCampusDynamic from '../views/bootScreen/campusDynamic/videoCampusDynamic.vue'
// 校园签到
import bootScreenSignIn from '../views/bootScreen/bootScreenSignIn/bootScreenSignIn.vue'
// 通知公告
import announcements from '../views/bootScreen/announcements/announcements.vue'
// 班级课程横屏
import curriculum from '../views/bootScreen/curriculum/curriculum.vue'
// 班级课程竖屏
import curriculumClasses from '../views/bootScreen/curriculumClasses/curriculumClasses.vue'
// 教室安排竖屏
import courseArrangement from '../views/bootScreen/classroomArrangement/courseArrangement.vue'
// 教室安排横屏
import classroomArrangement from '../views/bootScreen/classroomArrangement/classroomArrangement.vue'
// 院校文化
import collegeCulture from '../views/bootScreen/collegeCulture/collegeCulture.vue'
// 视频播放
import videoPlayback from '../views/bootScreen/videoPlayback/videoPlayback.vue'
// 下载页面
import downloadPage from '../views/downloadPage/downloadPage.vue'
// 预览详情iframe
import preFileIframe from '../views/preFileIframe/teasPreFileIframe.vue'
//竖屏签到
import attendance from '../views/bootScreen/attendance/attendance.vue'
//确认设备信息
import checkDevicePage from '../views/bootScreen/checkDevicePage.vue'
let router = [{
        path: "/downloadApp",
        meta: {
            title: "下载页面",
            needLogin: false,
        },
        component: downloadPage,
    },
    {
        path: "/preFileIframe",
        meta: {
            title: "预览",
            needLogin: false,
        },
        component: preFileIframe,
    },
    {
        path: "/mobile/bootScreen/checkDevicePage",
        meta: {
            title: "确认设备信息",
            needLogin: false,
        },
        component: checkDevicePage,
    },
    {
        path: "/mobile/bootScreen/transverse",
        meta: {
            title: "引导屏首页",
            needLogin: false,
            screenType: 0, //屏幕类型：0为横向，1为纵向
        },
        component: bootScreen,
        children: [{
                path: "schoolIntroduction",
                meta: {
                    title: "校园简介",
                    needLogin: false,
                    screenType: 0,
                },
                component: schoolIntroduction,
            },
            {
                path: "bigSchoolIntroduction",
                meta: {
                    title: "校园简介-大图",
                    needLogin: false,
                    screenType: 0,
                },
                component: bigSchoolIntroduction,
            },
            {
                path: "videoSchoolIntroduction",
                meta: {
                    title: "校园简介-视频",
                    needLogin: false,
                    screenType: 0,
                },
                component: videoSchoolIntroduction,
            },
            {
                path: "campusDynamic",
                meta: {
                    title: "校园动态",
                    needLogin: false,
                    screenType: 0,
                },
                component: campusDynamic,
            },
            {
                path: "bigCampusDynamic",
                meta: {
                    title: "校园动态-图片",
                    needLogin: false,
                    screenType: 0,
                },
                component: bigCampusDynamic,
            },
            {
                path: "videoCampusDynamic",
                meta: {
                    title: "校园动态-视频",
                    needLogin: false,
                    screenType: 0,
                },
                component: videoCampusDynamic,
            },
            {
                path: "announcements",
                meta: {
                    title: "通知公告",
                    needLogin: false,
                    screenType: 0,
                },
                component: announcements,
            },
            {
                path: "curriculum",
                meta: {
                    title: "班级课程",
                    needLogin: false,
                    screenType: 0,
                    hiddenLogo: 1,
                },
                component: curriculum,
            },
            {
                path: "classroomArrangement",
                meta: {
                    title: "教室安排",
                    needLogin: false,
                    screenType: 0,
                    hiddenLogo: 1,
                },
                component: classroomArrangement
            },
            {
                path: "bootScreenSignIn",
                meta: {
                    title: "签到",
                    needLogin: false,
                    screenType: 0,
                    hiddenTab: 1,
                },
                component: bootScreenSignIn,
            }
        ]
    },
    {
        path: "/mobile/bootScreen/longitudinal",
        meta: {
            title: "引导屏首页",
            needLogin: false,
            screenType: 1, //屏幕类型：0为横向，1为纵向
        },
        component: bootScreenShu,
        children: [{
                path: "schoolIntroduction",
                meta: {
                    title: "校园简介",
                    needLogin: false,
                    screenType: 1,
                },
                component: schoolIntroduction,
            },
            {
                path: "campusDynamic",
                meta: {
                    title: "校园动态",
                    needLogin: false,
                    screenType: 1,
                },
                component: campusDynamic,
            },
            {
                path: "bigCampusDynamic",
                meta: {
                    title: "校园动态-图片",
                    needLogin: false,
                    screenType: 1,
                },
                component: bigCampusDynamic,
            },
            {
                path: "announcements",
                meta: {
                    title: "通知公告",
                    needLogin: false,
                    screenType: 1,
                },
                component: announcements,
            },
            {
                path: "courseArrangement",
                meta: {
                    title: "教室安排",
                    needLogin: false,
                    screenType: 1,
                },
                component: courseArrangement,
            },
            {
                path: "curriculumClasses",
                meta: {
                    title: "班级课程",
                    needLogin: false,
                    screenType: 1,
                },
                component: curriculumClasses,
            },
            {
                path: "collegeCulture",
                meta: {
                    title: "院校文化",
                    needLogin: false,
                    screenType: 1,
                },
                component: collegeCulture,
            },
            {
                path: "videoPlayback",
                meta: {
                    title: "视频播放",
                    needLogin: false,
                    screenType: 1,
                },
                component: videoPlayback,
            },
        ]
    },
    {
        path: "/mobile/bootScreen/attendance",
        meta: {
            title: "签到",
            needLogin: false,
            screenType: 1,
        },
        component: attendance,
    },
];

export default router;